import request from '@/utils/request'

/**
 * 获取属性规格列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listAttrSpec(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attrSpec.listAttrSpec',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加属性规格
 * @param {Object} data 属性规格数据
 * @returns {Promise} Promise对象
 */
export function saveAttrSpec(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attrSpec.saveAttrSpec',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新属性规格
 * @param {Object} data 属性规格数据
 * @returns {Promise} Promise对象
 */
export function updateAttrSpec(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attrSpec.updateAttrSpec',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除属性规格
 * @param {Object} data 属性规格数据
 * @returns {Promise} Promise对象
 */
export function deleteAttrSpec(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attrSpec.deleteAttrSpec',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}